import { IOrder, IOrderItem, IPlan, ITrackingInfo } from './api';

/** 选择器类型 */
export enum ESelectorType {
    /** 多选 */
    MULTIPLE = 'multiple',
    /** 单选 */
    SINGLE = 'single'
}

export interface ISelectorStyle {
    widthOut: number;
    heightOut: number ;
    widthIn: number ;
    heightIn: number;
    selectMarginLeft: number;
    triangleRight: number;
    maxHeight: number;
    fontSizeIn?: number;
    fontSizeOut?: number;
    optionListMinWidth?: number;
}

export interface IReoSelectOption {
    label: string;
    value: string | number;
    id: string | number;

    selected?: boolean;

    sortOrder?: number;

    parentId?: number;
}

export enum ECommonButtonSize {
    SMALL = 'small',
    MIDDLE = 'middle',
    LARGE = 'large'
}

export enum ECommonButtonType {
    LIGHT = 'light',
    DARK = 'dark',
    RED = 'red',
}

export enum ECountrySelectStatus {
    SELECTING = 'selecting',
    SELECTED = 'selected'
}

export enum EPlanDisplayMode {
    VIEW = 'view',
    SELECT = 'select'
}

export interface IPlanCardItem {
    plan: IPlan;
    deviceInfo?: any;
    startedAt?: number;
    endingAt?: number;
    simCard?: string;
    quantity: number;
}

export interface IAdjustmentInfo { currency: string;amount: number; }

export type TAddressType='billing' | 'shipping';
export type TSelectionType='keen' | 'reolink';
export interface ISelectedAddress {
    selectionType: TSelectionType;
    addressType: TAddressType;
    index: number;
}
export type TSelectionAddress = ISelectedAddress | null;

export type TInvoiceOrderItem = Pick<IOrderItem, 'productId' | 'amount'  | 'quantity' | 'subTotal' | 'salePrice' | 'tax'|'unitPrice' | 'unitPriceExcludeTax' > &
{ context: {
    trackingInfo?: ITrackingInfo[];
    adjustment?: boolean;
    validTime?: any;
}; };
export type TInvoiceOrder = Omit<IOrder, 'user' | 'paymentMethod' | 'modifiedAt' | 'closedReason' > & { items: TInvoiceOrderItem[]; userEmail?: string; };

export interface IVFXBoxItem {
    value: string;
    placeholder: string;
    required: boolean;
    half: boolean;
    autocomplete: string;
    error: boolean | string;
}

export interface IDuration {
    title: string;
    unit: string;
    amount: number;
    discount?: string;
}

export interface IDiscount { title: string;details: string; }

export type TGetDiscountsResult = IDiscount[] | undefined;
